import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import menuPortalProps from 'helpers/reactSelectPortal';
import { currencyIcon } from 'helpers/currencyIcon';

/**
 * CurrencySelect — reusable currency picker with a per-currency sign icon
 * (VND ₫ / USD $ / THB ฿). Built on react-select so the icon renders inside the
 * control consistently across browsers (a native <select> + absolute icon
 * overlaps on Safari). Controlled via `value` + `onChange(value)`.
 *
 *   <CurrencySelect value={watch('currency')} onChange={(v) => setValue('currency', v, { shouldValidate: true })} />
 */
const DEFAULT_OPTIONS = ['VND', 'USD', 'THB'];

const formatOptionLabel = (o) => {
  const Icon = currencyIcon(o.value);
  return (
    <span className="tw-flex tw-items-center tw-gap-2">
      <Icon className="tw-text-amber-500" size={13} />
      {o.label}
    </span>
  );
};

const CurrencySelect = ({ value, onChange, options = DEFAULT_OPTIONS, disabled = false }) => {
  const opts = options.map((c) => ({ value: c, label: c }));
  return (
    <Select
      classNamePrefix="react-select"
      options={opts}
      value={opts.find((o) => o.value === value) || null}
      isDisabled={disabled}
      isSearchable={false}
      placeholder="Select..."
      formatOptionLabel={formatOptionLabel}
      onChange={(o) => onChange?.(o ? o.value : null)}
      {...menuPortalProps}
    />
  );
};

CurrencySelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
};

export default CurrencySelect;
